module.exports = __webpack_public_path__ + "img/pencil-square.98c217cf.svg";